import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  generateVoDreports({ state }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.VoDReport.vodOrderReport}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getVodOrderListDetails({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.VoDReport.vodGetOrderList}?orderId=${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getVodReport({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.VoDReport.viewReport}?orderId=${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getVodGenerateReport({ state }, orderId) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.VoDReport.generateOrder}?orderId=${orderId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  updateVodManual({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoDReport.updateVodManual}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  async sendVodVerification({ state }, orderID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoDReport.vodSendVerification}/${orderID}`,
        {},

        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  verifyVodOTP({ state }, { orderId, otpnumber }) {
    let url = `${appConfig.apiEndPoint}${endpoint.VoDReport.vodOtpScreen}/${orderId}/${otpnumber}`
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  vodResendOtp({ state }, { guid }) {
    let url = `${appConfig.apiEndPoint}${endpoint.VoDReport.vodResendOtp}/${guid}`
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  vodOtpExpire({ state }, guid) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.VoDReport.vodOtpExpire}/${guid}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getSecureLinkDetails({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoDReport.getSecureLink}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },

  saveSecureLinkDetails({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoDReport.saveSecureLink}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  uploadFiles({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoDReport.uploadDocument}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  deleteFiles({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.VoDReport.deleteDocument}`,
        payload,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
}
function setHeaders() {
  const path = window.location.href
  const url = path.includes('vod-otpscreen')
  const urldibuvoe = path.includes('voe-dibuscreen')
  const urldibuvod = path.includes('vod-dibuscreen')
  const urlvoe = path.includes('voe-securedlink')
  const urlvod = path.includes('vod-securedlink')
  if (url || urldibuvoe || urldibuvod || urlvoe || urlvod) {
    return {
      'Content-Type': 'application/json',
      Authorization: '',
    }
  } else {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
    }
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
